import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router/dom';
import { queryClient } from './lib/query-client';
import { searchRouter } from './search-router';
import './style.css';
import './features/search/search.css';

createRoot(document.getElementById('search-root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={searchRouter} />
    </QueryClientProvider>
  </StrictMode>,
);
